import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background text-muted-foreground">
        <div className="label-mono text-xs">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <Header />
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
        <footer className="border-t border-border px-6 py-4 text-xs text-muted-foreground flex flex-wrap gap-2 justify-between">
          <span>© DEBT-ANALYZER PRO · Méthodologie vitaliste : Ahmed ELY Mustapha</span>
          <span className="label-mono text-[9px]">
            « Chaque dollar emprunté est une vie hypothéquée »
          </span>
        </footer>
      </div>
      <Toaster richColors position="top-right" />
    </div>
  );
}
